<template>
    <div>
        <div class="header-return">
            <el-row>
                <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                         :size="GCONFIG.styleElFormSize">
                    <el-form-item label="">
                        <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                    </el-form-item>
                    <el-form-item>
                        <!--<el-button type="primary" @click="getList">查询</el-button>-->
                        <el-button type="success" @click="handleAdd()" class="header-btn">新建</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
        </div>
        <el-table :data="adList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="name" label="名称"  width="120"></el-table-column>
            <el-table-column prop="type" label="类型" width="100"></el-table-column>
            <el-table-column prop="sourceId"  label="数据源" width="200"></el-table-column>
            <el-table-column prop="description"  label="描述" width="180"></el-table-column>
            <el-table-column prop="adUrl"  label="广告投放url"  fixed="right" ></el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="新增/修改" :visible.sync="showDialog" center>
            <el-form :model="model" label-width="120px">
                <el-form-item label="举例说明">
                    <el-alert title="广告投放" type="success" :closable="false">
                    </el-alert>
                </el-form-item>
                <el-form-item label="名称" prop="name">
                    <el-input v-model="model.name" placeholder="名称"></el-input>
                    <span style="color: red">*根据实际情况写可以用广告投放名称(方便数据对应)</span>
                </el-form-item>
                <el-form-item label="类型" prop="type">
                    <!--<el-input v-model="model.type" :disabled="true" placeholder="类型"></el-input>-->
                    <!--<span style="color: red">*公众投放固定为WECHAT</span>-->
                    <el-select v-model="model.platformId"  placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="描述" prop="description">
                    <el-input v-model="model.description" placeholder="描述"></el-input>
                    <span style="color: red">*描述</span>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save()" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getPlatformList2,
        createAdDatasource,
        getAdSourceList
    } from '../../api/api';
    import {getRouterPageHash} from '@/api/http';
    export default {
        data() {
            return {
                showDialog: false,
                list: [],
                recordsTotal: 0,
                platformDisabled:true,
                formInline: {
                    currentPage: 1,
                    pageSize: 20
                },
                model: {
                    platformId: 1,
                    name: '',
                    description: ''
                },
                loading: true,
                adList:[],
                platformData: []
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getAllPlatformList();
            this.getAdSourceList();
        },
        methods: {
            getAllPlatformList() {
                getPlatformList2(this.formInline).then((res) => {
                    this.platformData=res.data;
                    this.model.platformId=res.data[0].platformId;
                });
            },

            getAdSourceList(){
                getAdSourceList().then((res) => {
                    this.adList = res.data.value;
                    this.recordsTotal=this.adList.length;
                    this.loading=false;
                });
            },
            handleAdd(){
                this.showDialog=true;
                this.platformDisabled=false;
                this.model= {
                    platformId: 1,
                    name: '',
                    description: ''
                };
            },
            handleEdit(data){
                this.showDialog=true;
                this.platformDisabled=true;
                this.model= {
                    platformId: data.type=='WECHAT'?1:(data.type=='WECHAT_MINI_PROGRAM'?4:0),
                    name: data.name,
                    description: data.description
                };
            },
            save(){
                if (this.model.description == '') {
                    this.$message({
                        message: '描述必须输入',
                        type: 'error'
                    });
                    return;
                }
                this.loading = true;
                createAdDatasource(this.model).then((res) => {
                    this.loading = false;
                    console.log(res);
                    if (res.data.success) {
                        this.getAdSourceList();
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });

                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/wechat/adSource.vue